import React, { useEffect, useState } from "react";
import { Maximize2, Minimize2, Radar as RadarIcon, RefreshCw } from "lucide-react";
import { Button } from "../components/ui/button";
import { StormDeskRadar } from "../components/StormDeskRadar";

const Radar = () => {
  const [isFull, setIsFull] = useState(false);

  useEffect(() => {
    const handler = () => setIsFull(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, []);

  const toggleFull = () => {
    const element = document.getElementById("wf-frame-wrap");
    if (!element) return;
    if (document.fullscreenElement) document.exitFullscreen();
    else element.requestFullscreen?.();
  };

  return (
    <div className="mx-auto max-w-7xl px-4 pt-6 sm:px-6">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="mono flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-cyan-400">
            <RadarIcon className="h-3.5 w-3.5" /> Storm Desk Radar
          </div>
          <h1 className="display-italic sd-title-gradient mt-1 text-4xl uppercase sm:text-5xl">Live storm tracking</h1>
          <p className="mt-2 max-w-2xl text-sm text-slate-400">
            Interactive Storm Desk radar with live, clickable National Weather Service alerts.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            onClick={() => window.location.reload()}
            data-testid="radar-refresh-button"
            className="h-9 gap-2 border-white/15 bg-white/[0.03] text-slate-100 hover:bg-white/[0.08]"
          >
            <RefreshCw className="h-4 w-4" /> Refresh
          </Button>
          <Button
            variant="outline"
            onClick={toggleFull}
            data-testid="radar-fullscreen-button"
            className="h-9 gap-2 border-white/15 bg-white/[0.03] text-slate-100 hover:bg-white/[0.08]"
          >
            {isFull ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />} Fullscreen
          </Button>
        </div>
      </div>

      <div id="wf-frame-wrap" className={isFull ? "bg-[#02040c]" : "overflow-hidden rounded-2xl"}>
        <StormDeskRadar
          height={isFull ? "100vh" : "max(620px, calc(100vh - 360px))"}
          initialPanelCollapsed={isFull}
          hideHeader={isFull}
        />
        {isFull && (
          <button
            type="button"
            onClick={toggleFull}
            data-testid="radar-exit-fullscreen-button"
            className="mono fixed right-4 top-4 z-[130] flex items-center gap-2 border border-white/20 bg-black/85 px-3 py-2 text-[11px] font-bold uppercase tracking-widest text-white shadow-xl hover:bg-black"
          >
            <Minimize2 className="h-4 w-4" /> Exit fullscreen
          </button>
        )}
      </div>
    </div>
  );
};

export default Radar;
